export var AttendanceStatus;
(function (AttendanceStatus) {
    AttendanceStatus["PRESENT"] = "present";
    AttendanceStatus["ABSENT"] = "absent";
})(AttendanceStatus || (AttendanceStatus = {}));
/** Format a Date as "YYYY-MM-DD" in local time. */
export function toDateString(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
/** Parse a "YYYY-MM-DD" string as a local-time Date at midnight. */
export function parseDateString(date) {
    const [year, month, day] = date.split('-').map(Number);
    return new Date(year, month - 1, day);
}
/** The start of the week (Sunday) or month containing `date`, as "YYYY-MM-DD". */
export function getAttendancePeriodStart(date, groupBy) {
    const d = parseDateString(date);
    if (groupBy === 'month') {
        return toDateString(new Date(d.getFullYear(), d.getMonth(), 1));
    }
    return toDateString(new Date(d.getFullYear(), d.getMonth(), d.getDate() - d.getDay()));
}
/** Every period start touching the inclusive range `from`..`to`, oldest first. */
export function listAttendancePeriods(from, to, groupBy) {
    const periods = [];
    const end = parseDateString(to);
    let cursor = parseDateString(getAttendancePeriodStart(from, groupBy));
    while (cursor <= end) {
        periods.push(toDateString(cursor));
        cursor = groupBy === 'month'
            ? new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1)
            : new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate() + 7);
    }
    return periods;
}
//# sourceMappingURL=attendance.js.map